"use client";

import { UserMultipleIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { PageCta } from "@matsuricon/ui/patterns/page-cta";
import { VolunteerRegistrationControl } from "./volunteer-registration-control";
import { useVolunteerRegistration } from "./volunteer-registration-provider";

export function VolunteerCta() {
  const { view } = useVolunteerRegistration();

  return (
    <PageCta
      id="volunteer-cta"
      eyebrow={view.ctaEyebrow}
      title={view.ctaTitle}
      description={view.ctaDescription}
      icon={<HugeiconsIcon aria-hidden="true" icon={UserMultipleIcon} strokeWidth={1.8} />}
      decoration={
        <div
          aria-hidden="true"
          className="absolute top-0 right-0 size-56 translate-x-1/3 -translate-y-1/3 rounded-full bg-brand-secondary/15 blur-3xl"
        />
      }
    >
      <VolunteerRegistrationControl label="Open Volunteer Application" className="w-full lg:w-auto" />
    </PageCta>
  );
}
